export const getInventoryData = (inventoryList: any) => {
  return inventoryList?.invetories?.map((data: any) => ({
    id: data?.id || "-",
    itemID: data?.itemCode || "-",
    itemName: data?.itemName || "-",
    category: data?.type || "-",
    currentStock: data?.quantity ?? "-",
    reorderPoint: data?.threshold || "-",
    status: data?.status.split("_").join(" ") || "",
    batchNumber: data?.logisticsInfo?.batchNumber || "-",
    purchaseUnit: data?.logisticsInfo?.unit || "-",
    stockKeepingUnit: data?.skuCode || "-",
    supplierName: data?.logisticsInfo?.name || "-",
    unitOfMeasure: data?.unitOfMeasure || "-",
  }));
};
